export default __webpack_public_path__ + "static/media/Barlow-MediumItalic.6f47e0b5.otf";